import { CONFIG } from 'config/config';
import { UiWrapper } from '@coinscrap/webapp-core';

UiWrapper.defineComponent('text', {
	styles: {
		// BASIC
		default: {
			color: CONFIG.colors.black,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.md,
		},

		headingPrimarySt: {
			color: CONFIG.colors.black,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.xl,
			textAlign: 'left',
		},

		headingSecondarySt: {
			color: CONFIG.colors.black,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.lg,
			textAlign: 'center',
		},

		headingTertiarySt: {
			color: CONFIG.colors.grey,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.lg,
			textAlign: 'center',
		},

		headingSubtitleSt: {
			color: CONFIG.colors.black,
			fontSize: CONFIG.fontSizes.md,
			width: '100%',
			paddingTop: 5,
		},

		stepsSt: {
			color: CONFIG.colors.grey,
			fontFamily: CONFIG.fonts.light,
			fontSize: CONFIG.fontSizes.lg,
			textAlign: 'center',
		},

		errorSt: {
			color: CONFIG.colors.danger,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.lg,
			textAlign: 'center',
		},

		textLeftSt: {
			textAlign: 'left',
		},

		// INPUTS
		labelInputSt: {
			color: CONFIG.colors.grey,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.md,
			marginBottom: 12,
			marginTop: 30,
		},

		labelInputLanguageSt: {
			color: CONFIG.colors.grey,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.md,
			marginBottom: 0,
			marginTop: 0,
		},

		inputSelectOptionsSt: {
			color: CONFIG.inputs.selectOptions.color,
			fontSize: CONFIG.inputs.selectOptions.fontSize,
			fontFamily: CONFIG.inputs.selectOptions.fontFamily,
		},

		inputSelectedOptionsSt: {
			color: CONFIG.inputs.color,
			fontSize: CONFIG.inputs.fontSize,
			fontFamily: CONFIG.inputs.fontFamily,
		},

		errorInputSt: {
			color: CONFIG.colors.danger,
			fontSize: CONFIG.fontSizes.sm,
			fontFamily: CONFIG.fonts.semiBold,
			marginTop: 10,
			alignSelf: 'flex-start',
		},

		errorLinkInputSt: {
			textDecoration: 'underline',
			cursor: 'pointer',
			marginLeft: 4,
		},

		// LANDING
		landingHeaderSt: {
			color: CONFIG.colors.white,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.xl5,
			textAlign: 'center',
		},

		// BENEFICIARY LIST
		benefKeySt: {
			color: CONFIG.colors.primary,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.md,
			textAlign: 'left',
		},

		// PACKAGES TABLE
		coverageFirstCellSt: {
			color: CONFIG.colors.black,
			fontSize: CONFIG.fontSizes.md,
			width: '100%',
			padding: 20,
		},
		coverageCellSt: {
			color: CONFIG.colors.primary,
			fontSize: CONFIG.fontSizes.md,
			width: '100%',
			paddingRight: 10,
		},
		coverageMobileCellSt: {
			color: CONFIG.colors.primaryDark,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
			width: '100%',
			paddingRight: 10,
		},
		coverageMobileHeaderSt: {
			color: CONFIG.colors.primaryDark,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
		},
		packHeaderCellSt: {
			color: CONFIG.colors.white,
			fontSize: CONFIG.fontSizes.md,
			fontFamily: CONFIG.fonts.light,
			width: '100%',
			padding: 20,
			textAlign: 'center',
		},
		packCellSt: {
			color: CONFIG.colors.success,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
		},
		packCellMobileTitleSt: {
			color: CONFIG.colors.grey,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
		},
		packCellMobileValueSt: {
			color: CONFIG.colors.success,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
		},
		packReceiptSt: {
			color: CONFIG.colors.black,
			fontSize: CONFIG.fontSizes.lg,
			fontFamily: CONFIG.fonts.semiBold,
			width: '100%',
			//paddingTop: 10,
			textAlign: 'center',
		},
		packSubReceiptSt: {
			color: CONFIG.colors.black,
			fontSize: CONFIG.fontSizes.md,
			fontFamily: CONFIG.fonts.semiBold,
			width: '100%',
			paddingBottom: 10,
			textAlign: 'center',
		},
		packSubReceiptMobileSt: {
			color: CONFIG.colors.black,
			fontSize: CONFIG.fontSizes.xs,
			fontFamily: CONFIG.fonts.semiBold,
			width: '100%',
			paddingBottom: 10,
			textAlign: 'center',
		},

		// POLÍTICA DE PRIVACIDAD
		policyDetailTitleSt: {
			color: CONFIG.colors.primary,
			fontFamily: CONFIG.fonts.bold,
		},
		policyDetailDescriptionSt: {
			color: CONFIG.colors.primary,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.xs,
			width: '100%',
		},

		// DASHBOARD
		progressTextSt: {
			color: CONFIG.colors.grey,
			fontFamily: CONFIG.fonts.regular,
			fontSize: CONFIG.fontSizes.lg,
		},

		activeProgressTextSt: {
			color: CONFIG.colors.primary,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.lg,
		},

		activeProgressErrorTextSt: {
			color: CONFIG.colors.danger,
			fontFamily: CONFIG.fonts.semiBold,
			fontSize: CONFIG.fontSizes.lg,
		},

		packagesDownloadPdfSt: {
			textDecoration: 'underline',
			cursor: 'pointer',
		},

		packagesDownloadPdfMobileSt: {
			color: CONFIG.colors.primary,
			fontFamily: CONFIG.fonts.semiBold,
		},

		mutedSt: {
			fontSize: CONFIG.fontSizes.sm,
			color: CONFIG.colors.greyDark,
			fontFamily: CONFIG.fonts.light,
			fontStyle: 'italic',
		},

		...CONFIG.commonStyles.styles,
	},
});
